/* Fit "Special Edition" to the width of "Flora & Fauna" (James 2026-10-01). The menu panels are hidden
   until opened, so widths are read when each label becomes visible (ResizeObserver), not at load. */
(function () {
  if (window.__bokjaFF) return; window.__bokjaFF = true;
  function fit(el) {
    var main = el.querySelector('.bokja-fflabel__main'), sub = el.querySelector('.bokja-fflabel__sub');
    if (!main || !sub) return;
    var W = main.getBoundingClientRect().width; if (!W) return;
    sub.style.letterSpacing = '0px'; sub.style.marginInlineEnd = '0px';
    var w = sub.getBoundingClientRect().width, n = sub.textContent.length;
    if (n < 2) return;
    var ls = (W - w) / (n - 1);
    sub.style.letterSpacing = ls + 'px';
    sub.style.marginInlineEnd = (-ls) + 'px';
  }
  function init() {
    var els = document.querySelectorAll('[data-bokja-ff]');
    var ro = 'ResizeObserver' in window ? new ResizeObserver(function (es) { es.forEach(function (e) { fit(e.target); }); }) : null;
    els.forEach(function (el) { fit(el); if (ro) ro.observe(el); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { els.forEach(fit); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
